import { makeStyles } from "@material-ui/core/styles";
export const useAppStyles = makeStyles((theme) => ({
  transitionGroupRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
}));
